var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mb-2", attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [_c("h5", {}, [_vm._v("Документы")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: _vm.isDisabled
                          },
                          on: { click: _vm.onAdd }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "plus" }
                          }),
                          _vm._v("\n            Добавить\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { staticClass: "mx-0 border-0", attrs: { "no-body": "" } },
            [
              _c("b-table", {
                ref: "location_files",
                staticClass: "mb-0",
                attrs: {
                  id: "location-files",
                  selectable: "",
                  "select-mode": "single",
                  selectedVariant: "success",
                  striped: "",
                  small: "",
                  "thead-class": "top-fixed-thead thead-light",
                  "table-class": "text-small",
                  responsive: "",
                  "show-empty": "",
                  "empty-text": _vm.$t("message.common.emptyTable"),
                  busy: _vm.isBusy,
                  items: _vm.items,
                  fields: _vm.fields,
                  "no-provider-filtering": "",
                  "no-provider-paging": "",
                  "no-provider-sorting": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-success my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Загрузка")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(path)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-link",
                          {
                            on: {
                              click: function($event) {
                                return _vm.onDownload(
                                  row.item.id,
                                  row.item.path
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(row.item.path))]
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(action)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button",
                          {
                            staticClass: "ml-3",
                            attrs: {
                              size: "sm",
                              variant: "danger",
                              disabled: _vm.isDisabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.onRemove(row)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "trash" }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card-footer",
            { attrs: { "footer-bg-variant": "light" } },
            [
              _c(
                "b-row",
                { attrs: { "align-h": "between", "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [
                      _vm._v("\n          Всего файлов: "),
                      _c("b", [_vm._v(_vm._s(_vm.items.length))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("b-pagination", {
                        attrs: {
                          id: "location-files-pagination",
                          pills: "",
                          "total-rows": _vm.items.length,
                          "per-page": _vm.perPage
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_file",
          attrs: {
            id: "modal-file",
            title: "Загрузка файла",
            "ok-title": "Добавить",
            "ok-variant": "success",
            "cancel-title": "Отменить",
            "button-size": "sm"
          },
          on: { show: _vm.onResetModal, hidden: _vm.onResetModal, ok: _vm.onOk }
        },
        [
          _c(
            "form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c("b-form-file", {
                attrs: { id: "input_number", size: "sm", autocomplete: "off" },
                model: {
                  value: _vm.newFile,
                  callback: function($$v) {
                    _vm.newFile = $$v
                  },
                  expression: "newFile"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4078b79e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4078b79e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationFiles.vue
// module id = null
// module chunks = 